<app-page-header [print]="print" subtitle="Weekplanning">
    <div class="performer-selector d-flex align-items-center gap-2" filters>
        <ng-container *ngTemplateOutlet="pageFilters"></ng-container>
    </div>

    <div class="d-flex flex-wrap gap-3" menu-filters>
        <ng-container *ngTemplateOutlet="pageFilters"></ng-container>
    </div>

    <ng-template #pageFilters>
        <ng-container *ngTemplateOutlet="filterSoortPlanning"></ng-container>
        <ng-container *ngTemplateOutlet="filterProjectleider"></ng-container>
    </ng-template>

    <app-date-indicator
        [fullWith]="true"
        [fromDate]="fromDate"
        [primaryWeekEnd]="toDate"
        [primaryWeekStart]="fromDate"
        [print]="print"
        [toDate]="toDate"
        (next)="next()"
        (prev)="prev()"
        indicator />

    <div class="d-flex mx-2" print-pdf>
        @if (!readOnly) {
            <button
                class="menu-button"
                (click)="onBehoefteButtonClick($event)"
                mat-icon-button
                matTooltip="Behoefte (ctrl+klik voor apart scherm)"
                matTooltipPosition="below"
                aria-label="Behoefte">
                <mat-icon class="calendar-icon" fontSet="far" fontIcon="fa-list-check" />
            </button>
        }

        <input
            #dateInput
            [matDatepicker]="picker"
            (dateChange)="onDateSelected($event)"
            matInput
            style="border: none; width: 0px; height: 0px" />

        <button
            class="menu-button"
            (click)="picker.open()"
            color="primary"
            mat-icon-button
            matTooltip="Selecteer datum"
            matTooltipPosition="below"
            aria-label="Selecteer datum">
            <mat-icon class="calendar-icon" fontSet="far" fontIcon="fa-calendar-range" />
        </button>

        <mat-datepicker #picker [touchUi]="mobile"></mat-datepicker>
    </div>
</app-page-header>

<ng-template #filterSoortPlanning>
    <mat-form-field class="planning-filter-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Selecteer planning</mat-label>
        <mat-select [formControl]="fcFilteredEntityTypes" multiple>
            @for (entityType of environment.planningEntityTypes; track entityType.key) {
                <mat-option [value]="entityType.key">{{ entityType.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</ng-template>

<ng-template #filterProjectleider>
    <mat-form-field class="planning-filter-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Selecteer projectleider</mat-label>
        <mat-select [formControl]="fcProjectManager">
            <mat-option [value]="null">Alle projectleiders</mat-option>
            @for (projectManager of projectManagers; track projectManager.id) {
                <mat-option [value]="projectManager.id">{{ projectManager.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</ng-template>

<div class="week-planning" (contextmenu)="$event.preventDefault()" cdkDropListGroup>
    <div class="week" #weekContainer>
        <div class="day times-day">
            <div class="date">&nbsp;</div>

            @if (!mobile) {
                <div class="employees d-flex justify-content-center align-content-center">
                    <i class="fa-solid fa-user-helmet-safety"></i>
                </div>
            }

            <div class="timeline">
                <div class="times-on-day">
                    @for (time of times; track time) {
                        <div class="time" data-testid="weekplanning-time-label">
                            {{ time | date: 'H:mm' }}
                        </div>
                    }
                </div>
            </div>
        </div>

        @for (day of weekPlanning; track day.date.getTime()) {
            <div
                class="day"
                [attr.data-date]="day.date | date: 'yyyy-MM-dd'"
                [attr.data-testid]="'weekplanning-day-' + (day.date | date: 'yyyy-MM-dd')">
                <div
                    class="date"
                    [class.fixed-right]="Features.PlanningFixedSave | hasFeature"
                    [class.fixed]="day.fixed"
                    (click)="setFixed(day)"
                    (mouseenter)="mouseEnterFixDate(day)"
                    (mouseleave)="mouseLeaveFixDate()">
                    {{ day.date | date: 'EEEE' }}
                    <span class="datenumber">
                        {{ day.date | date: 'd MMM' }}
                    </span>
                </div>

                @if (!mobile) {
                    <div
                        class="employees"
                        id="day-{{ day.date | date: 'yyyy-MM-dd' }}"
                        [cdkDropListData]="day"
                        [cdkDropListEnterPredicate]="mayDrop"
                        (cdkDropListDropped)="drop($event)"
                        cdkDropList>
                        <div
                            class="employee-badge"
                            [cdkDragData]="{ id: 'hire', name: 'inhuur' }"
                            [cdkDragDisabled]="readOnly"
                            (cdkDragStarted)="someDayDragging = true"
                            (cdkDragEnded)="someDayDragging = false"
                            cdkDrag>
                            Inhuur <i class="fa-regular fa-user-plus"></i>
                        </div>

                        @for (
                            employee of day | employeeState: userPlannings : planningList : fcFilteredEntityTypes.value;
                            track employee.user.id
                        ) {
                            @let leave = leaveDayUserMap.get(employeeService.makeKey(day.date, employee.user.id));

                            <div
                                class="employee-badge"
                                [matTooltip]="
                                    leave?.comment ? `${(leave.hourtype | hourtype)}:\n${leave?.comment}` : ''
                                "
                                [cdkContextMenuTriggerFor]="employeeContextMenu"
                                [cdkContextMenuTriggerData]="{ employee, day }"
                                [cdkDragDisabled]="employee.inUseInOtherPlanning || readOnly"
                                [cdkDragData]="employee.user"
                                [class.night]="employee.night"
                                [class.unavailable]="employee.unAvailable"
                                [class.deleted]="employee.user?.deleted_at || employee.user?.enddate"
                                [class.in-use-other]="employee.inUseInOtherPlanning"
                                (cdkDragStarted)="someDayDragging = true"
                                (cdkDragEnded)="someDayDragging = false"
                                cdkDrag>
                                {{ employee.user.name }}

                                @if (employee?.duration !== 8 && employee.unAvailable) {
                                    ({{ employee?.duration }})
                                }

                                <i class="fa-solid" *ngIf="employee.icon" [class]="employee.icon"></i>
                            </div>
                        }
                    </div>
                }

                <div class="timeline" [id]="day.date | date: 'yyyy-MM-dd'">
                    <app-track-line-week-day
                        #day
                        [readOnly]="readOnly"
                        [startHour]="startHour"
                        [hoursOnDay]="hoursOnDay"
                        [isDragging]="someDayDragging"
                        [planningList]="planningList"
                        [day]="day | dayEntityTypeFilter: fcFilteredEntityTypes.value : fcProjectManager.value"
                        [leaves]="leaves"
                        (dragging)="someDayDragging = $event"
                        (focusOnMapId)="focusOnMapId($event)" />
                </div>
            </div>
        }
    </div>

    @if (!readOnly) {
        <div class="need-overview border border-light">
            <div class="content" id="needOverviewList">
                <div class="need-header">
                    <div class="title">Behoefte</div>

                    <div>
                        <i
                            class="far fa-external-link-alt px-3"
                            (click)="openBehoefteInNewTab()"
                            matRipple
                            matTooltip="Behoefte op apart scherm openen"></i>
                        <i class="far fa-plus px-3" (click)="newPlanning()" matRipple></i>
                    </div>
                </div>

                <div>
                    <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic">
                        <input
                            [formControl]="fcSearchNeed"
                            (keydown.escape)="fcSearchNeed.setValue('')"
                            matInput
                            placeholder="Zoek behoefte" />

                        @if (fcSearchNeed.value) {
                            <button
                                (click)="fcSearchNeed.setValue('')"
                                matSuffix
                                type="button"
                                mat-icon-button
                                aria-label="Clear">
                                <i class="fas fa-times"></i>
                            </button>
                        }
                    </mat-form-field>
                </div>

                <div class="need-items h-50">
                    @for (
                        need of visibleNeedOverview
                            | filterByEntityType
                                : fcFilteredEntityTypes.value
                                : fcSearchNeed.value
                                : materialsById
                                : fcProjectManager.value;
                        track need.id
                    ) {
                        <app-need-item
                            [need]="need"
                            [readOnly]="readOnly"
                            [materialsById]="materialsById"
                            [contextMenu]="needContextMenu"
                            (dragEnded)="dragNeedEnded($event)"
                            (open)="openPlanning($event)"
                            (hoverChange)="hoveredNeedId = $event" />
                    }
                </div>

                <ng-template #needContextMenu let-need="need">
                    <div class="context-menu" cdkMenu>
                        <button class="menu-item" (click)="planningMap.focus(need.id)" cdkMenuItem>
                            <i class="fa-regular fa-map"></i> Toon op kaart
                        </button>
                    </div>
                </ng-template>

                <div class="h-50 map-container border-top border-dark">
                    <app-planning-map
                        #planningMap
                        [plannings]="planningsAndNeedsToShowOnMap"
                        [hoverPlanningId]="hoveredNeedId ?? highlightService.hoveredPlanningId"
                        (planningClick)="openPlanning($event)"
                        (showAll)="fcSearchNeed.setValue('')"
                        (mapFilterChange)="onMapFilterChange($event)"
                        (visiblePlanningIdsChange)="filterNeedsByMap($event)"
                        (planningHover)="onPlanningHover($event)" />
                </div>
            </div>
        </div>
    }
</div>

<ng-template #employeeContextMenu let-employee="employee" let-day="day">
    @let leave = leaveDayUserMap.get(employeeService.makeKey(day.date, employee.user.id));

    <div class="context-menu" cdkMenu>
        <div class="menu-title">
            {{ employee.user?.name }}
        </div>

        <mat-divider />

        <button class="menu-item info" (click)="showInfoDialog(employee.user, day.date)" cdkMenuItem>
            <i class="fa-regular fa-memo-circle-info"></i> Dag details
        </button>

        @if (!readOnly) {
            <mat-divider />

            @if (employee.user?.afas_employee_id | afasEmployeeType: 'Z') {
                <button
                    class="menu-item"
                    [class.active]="leave?.hourtype === RealisationHourtype.zzp_leave"
                    (click)="toggleLeave(employee.user, day.date, RealisationHourtype.zzp_leave)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.zzp_leave | hourtypeIcon }}"></i> ZZP N/b
                </button>
            } @else {
                @for (
                    hourtype of [
                        RealisationHourtype.not_available,
                        RealisationHourtype.illness,
                        RealisationHourtype.frost,
                        RealisationHourtype.time_for_time,
                        RealisationHourtype.paid_leave,
                        RealisationHourtype.short_absence,
                        RealisationHourtype.education,
                        RealisationHourtype.sleep,
                    ];
                    track hourtype
                ) {
                    <button
                        class="menu-item"
                        [class.active]="leave?.hourtype === hourtype"
                        (click)="toggleLeave(employee.user, day.date, hourtype)"
                        cdkMenuItem>
                        <i class="fa-solid {{ hourtype | hourtypeIcon }}"></i> {{ hourtype | hourtype }}
                    </button>
                }
            }
        }
    </div>
</ng-template>
